module.exports = __webpack_public_path__ + "img/service-duanxin2.961fee79.svg";